import { render, staticRenderFns } from "./ui-link.vue?vue&type=template&id=dfcce922&"
import script from "./ui-link.vue?vue&type=script&lang=js&"
export * from "./ui-link.vue?vue&type=script&lang=js&"
import style0 from "./ui-link.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/funday/funday/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dfcce922')) {
      api.createRecord('dfcce922', component.options)
    } else {
      api.reload('dfcce922', component.options)
    }
    module.hot.accept("./ui-link.vue?vue&type=template&id=dfcce922&", function () {
      api.rerender('dfcce922', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/src/components/kit/ui-link/ui-link.vue"
export default component.exports